import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'
import SendInviteForm from 'forms/shared/passport-form/send-invite'

const form = 'passport-send-invite-form'

const PassportInvite = ({ onClose, handleSubmit }) => (
  <Modal contentClassName="" onClose={onClose} headerClose={false}>
    <div className="flex flex-row-reverse">
      <i onClick={onClose} className="fa fa-times py-3 px-4 cursor-pointer text-gray-600" aria-hidden="true"></i>
    </div>
    <div className="py-2 px-12 font-semibold text-lg">Invite members of your organization</div>
    <div className="px-12 pb-16">
      <SendInviteForm onSubmit={values => handleSubmit(values)} form={form} />
    </div>
  </Modal>
)

PassportInvite.propTypes = {
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func.isRequired,
}

export default PassportInvite
